export const includesError = (
	errors: readonly { message: string }[] | undefined,
	message: string
) => {
	return errors?.some((error) => error.message.startsWith(message));
};
